<template>
  <router-view />
  <GlobalModal />
</template>

<script setup>
import GlobalModal from '@/components/GlobalModal.vue';
</script>

<style>
</style>
